import { useQueries, useQueryClient } from '@tanstack/react-query';

import { buildGetSelectionAllQueryKey } from './useSelectionData';
import { useSharedMenuData } from './useSharedMenuData';
import { getSelectionBootstrappingStatus } from '../api';
import { OfferingPlatformScope, SharedMenu, SelectionBootstrappingStatusResponse } from '../types';

type Props = {
  enabled: boolean;
  scope: OfferingPlatformScope;
  selections: SharedMenu[];
  onResolve?: (status: SelectionBootstrappingStatusResponse['status'], selection: SharedMenu) => void;
};

export const useParallelBootstrapStatusPolling = ({ enabled, scope, selections, onResolve }: Props) => {
  const queryClient = useQueryClient();
  const { updateSharedMenuStatus } = useSharedMenuData({ scope });

  useQueries({
    queries: selections.map(selection => {
      return {
        enabled,
        queryKey: ['selection-bootstrapping-status', selection.id],
        queryFn: () => getSelectionBootstrappingStatus(selection.id),
        refetchInterval: 1000,
        // TODO: rework logic as onSuccess will be deprecated in the next react-query version
        onSuccess: (data: SelectionBootstrappingStatusResponse) => {
          if (data.status === 'success' || data.status === 'failure') {
            updateSharedMenuStatus(selection.id, { bootstrapping: data });
            queryClient.resetQueries({ queryKey: buildGetSelectionAllQueryKey(selection.id, true) });
            onResolve?.(data.status, selection);
          }
        },
      };
    }),
  });
};
